import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation SubmitChatButtonMessage($chatId: ID!, $messageId: ID!) {
    submitChatButtonMessage(chatId: $chatId, messageId: $messageId) {
      id
    }
  }
`);
